import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { url } from 'statics';
import { Currency, ErrorResponse, ListResponse } from 'types';

const useCurrencies = ({
  queries,
  enabled,
}: {
  queries: {
    type?: Currency['type'];
    countries?: string;
  };
  enabled?: boolean;
}): UseQueryResult<ListResponse<Currency>, ErrorResponse> => {
  let queryParams = '?';
  const entries = Object.entries(queries);
  if (entries.length > 0) {
    entries.forEach(([key, value], i) => {
      queryParams += `${key}=${value}${i === entries.length - 1 ? '' : '&'}`;
    });
  }

  return useQuery([`${url.currencies}${queryParams}`], {
    enabled,
  });
};
export default useCurrencies;
